import { PermanentDeletionDurationLabel } from '@frameio/vapor';
import { getDurationUntilAssetHardDeletion } from '../utils';
import TEXT from './generated/TEXT/PermanentDeletionLabel';

type Props = {
  deletedAt: string;
};

export const PermanentDeletionLabel = ({ deletedAt }: Props) => {
  const [formattedDuration, isDeletionSoon] =
    getDurationUntilAssetHardDeletion(deletedAt);

  if (formattedDuration === '') {
    return null;
  }

  return (
    <span
      aria-label={String(TEXT.permanentDeletionTooltip(formattedDuration))}
      role="img"
    >
      <PermanentDeletionDurationLabel
        duration={formattedDuration}
        isSoon={isDeletionSoon}
        tooltipTitle={
          TEXT.permanentDeletionTooltip(formattedDuration) as string
        }
      />
    </span>
  );
};

TEXT.DEFINE({
  permanentDeletionTooltip: (duration: string) =>
    `This asset will be permanently deleted in ${duration}`,
});
